<div class="n-oldalfej">
  <div>
    <h2>Reprezentáció és üzleti ajándék</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · egyes meghatározott juttatás, nem személyhez kötve</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button (click)="uj()" [disabled]="!betoltve"><ion-icon slot="start" name="add-outline"></ion-icon>Új tétel</ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId && betoltve">
  <div class="n-szuro-sor">
    <span class="cimke">Adóalap: érték × {{ tizedes(param?.adoalap_szorzo) }}</span>
    <span class="cimke">SZJA {{ szazalek(param?.szja_kulcs) }}%</span>
    <span class="cimke" *ngIf="!kivas">Szocho {{ szazalek(param?.szocho_kulcs) }}%</span>
    <span class="cimke sarga" *ngIf="kivas">KIVA-alany: szocho helyett KIVA-alap</span>
    <div class="spacer"></div>
    <button type="button" class="ov-gomb" (click)="ujraszamol()" [disabled]="!sorok.length" title="A tételek közterheinek újraszámolása az aktuális paraméterekkel">
      <ion-icon name="refresh-outline"></ion-icon>Újraszámolás</button>
    <button type="button" class="ov-gomb" (click)="nyomtat()" [disabled]="!sorok.length"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button>
    <button type="button" class="ov-gomb" (click)="parameterek()"><ion-icon name="options-outline"></ion-icon>Paraméterek</button>
  </div>

  <div class="ata-kpi" *ngIf="sorok.length">
    <div class="n-panel ata-k"><span>Reprezentáció</span><b>{{ ft(tipusOssz('reprezentacio')) }} Ft</b><small>{{ idoszak }}</small></div>
    <div class="n-panel ata-k"><span>Üzleti ajándék</span><b>{{ ft(tipusOssz('uzleti_ajandek')) }} Ft</b><small>{{ idoszak }}</small></div>
    <div class="n-panel ata-k ata-teher"><span>Közteher</span><b>{{ ft(osszesen.szja + osszesen.szocho) }} Ft</b>
      <small>SZJA {{ ft(osszesen.szja) }}<ng-container *ngIf="!kivas"> · szocho {{ ft(osszesen.szocho) }}</ng-container><ng-container *ngIf="kivas"> · KIVA-alapba {{ ft(osszesen.kiva_alap) }}</ng-container></small></div>
  </div>

  <div class="ures" *ngIf="!sorok.length">
    <ion-icon name="wine-outline"></ion-icon>{{ idoszak }}: nincs rögzített reprezentáció vagy üzleti ajándék.
  </div>

  <div class="tabla-wrap" *ngIf="sorok.length">
    <table class="n-racs">
      <thead><tr>
        <th>Dátum</th><th>Típus</th><th>Megnevezés</th>
        <th class="num">Érték</th><th class="num cs-afa">Adóalap</th>
        <th class="num cs-penz">SZJA</th><th class="num cs-penz">{{ kivas ? 'KIVA-alapba' : 'Szocho' }}</th>
        <th>Megjegyzés</th><th></th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let s of sorok" (dblclick)="modosit(s)">
          <td>{{ s.datum }}</td>
          <td><span class="cimke" [class.petrol]="s.tipus === 'uzleti_ajandek'">{{ s.tipus_cim }}</span></td>
          <td><div class="n-ket-sor" [title]="s.megnevezes || ''">{{ s.megnevezes }}</div></td>
          <td class="num">{{ ft(s.ertek) }}</td>
          <td class="num cs-afa">{{ ft(s.adoalap) }}</td>
          <td class="num cs-penz">{{ ft(s.szja) }}</td>
          <td class="num cs-penz">{{ ft(kivas ? s.kiva_alap : s.szocho) }}</td>
          <td><span class="cimke zold" *ngIf="s.adomentes">adómentes</span> <span class="halvany">{{ s.megjegyzes }}</span></td>
          <td class="ber-muv">
            <button type="button" class="kv-mini" (click)="modosit(s)" title="Módosítás"><ion-icon name="create-outline"></ion-icon></button>
            <button type="button" class="kv-torol" (click)="torol(s)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
          </td>
        </tr>
      </tbody>
      <tfoot><tr>
        <td colspan="3">Összesen ({{ sorok.length }} tétel)</td>
        <td class="num">{{ ft(osszesen.ertek) }}</td>
        <td class="num cs-afa">{{ ft(osszesen.adoalap) }}</td>
        <td class="num cs-penz">{{ ft(osszesen.szja) }}</td>
        <td class="num cs-penz">{{ ft(kivas ? osszesen.kiva_alap : osszesen.szocho) }}</td>
        <td colspan="2"></td>
      </tr></tfoot>
    </table>
  </div>

  <div class="n-panel ata-info jt-info">
    <div class="n-panel-cim">Hogyan számol</div>
    <ul>
      <li>A <b>reprezentáció</b> és az <b>üzleti ajándék</b> egyes meghatározott juttatás (Szja tv. 70. §): adóalap = érték × {{ tizedes(param?.adoalap_szorzo) }},
        SZJA {{ szazalek(param?.szja_kulcs) }}%<ng-container *ngIf="!kivas">, szocho {{ szazalek(param?.szocho_kulcs) }}%</ng-container>.</li>
      <li *ngIf="kivas">KIVA-alanynál szocho nincs: a juttatás adóalapja a <b>KIVA alapjába</b> (személyi jellegű kifizetés) tartozik – NAV 92. füzet.</li>
      <li>Ami a jogszabály szerint nem adóköteles (pl. adómentes vendéglátás), azt „adómentes” jelöléssel rögzítsd: a listában
        benne marad, közterhe nincs. A mentesség feltételeit a hatályos Szja tv. alapján ellenőrizd.</li>
      <li>Az érték a juttatás bruttó (ÁFA-val növelt) értéke. A közterhek a juttatás negyedévét követő hónap 12-éig esedékesek.</li>
    </ul>
  </div>
</ng-container>

<ion-modal #szerkModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi()">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? 'Tétel módosítása' : 'Új tétel' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szerkModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zarSor"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Típus</span>
          <select [(ngModel)]="szerk.tipus"><option *ngFor="let t of tipusok" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <label class="kv-mezo"><span>Dátum *</span><input type="date" [(ngModel)]="szerk.datum"></label>
        <label class="kv-mezo"><span>Megnevezés</span><input type="text" [(ngModel)]="szerk.megnevezes" maxlength="160" placeholder="pl. üzleti vacsora, partnerajándék"></label>
        <label class="kv-mezo"><span>Érték (bruttó Ft) *</span><input type="number" min="0" [(ngModel)]="szerk.ertek"></label>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes" maxlength="255"></label>
        <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="szerk.adomentes"> Adómentes (nincs közteher)</label></div>
        <div class="ho-szamitott" *ngIf="elonezet(szerk) as e">
          <span>Adóalap: <b>{{ ft(e.adoalap) }}</b></span>
          <span>SZJA: <b>{{ ft(e.szja) }}</b></span>
          <span *ngIf="!kivas">Szocho: <b>{{ ft(e.szocho) }}</b></span>
          <span *ngIf="kivas">KIVA-alapba: <b>{{ ft(e.adoalap) }}</b></span>
        </div>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="ment()" [disabled]="mentes || (zarSor && !zarSor.irhato)"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal #paramModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Paraméterek – {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="paramModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <app-ber-juttatas-param [ugyfelId]="aktiv.ugyfelId" [ev]="aktiv.ev" [csoportok]="['kozos']" (mentve)="paramMentve()"></app-ber-juttatas-param>
    </div>
  </ng-template>
</ion-modal>
